var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-wrapper"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('transition',{attrs:{"name":"dim"}},[(_vm.modal)?_c('div',{staticClass:"modal-backdrop",on:{"click":_vm.hideModal}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }